export default {
  methods: {
    async onUpdateConversationsBulk(status) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Conversation',
          ids: this.conversations,
          fields: {
            status,
          },
        });
        this.showAlert(
          this.$t('BULK_ACTION.UPDATE.UPDATE_SUCCESFUL'),
          'success'
        );
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.UPDATE.UPDATE_FAILED'), 'error');
      }
    },
    async onAssignTeamsForBulk(team) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Conversation',
          ids: this.conversations,
          fields: {
            team_id: team.id,
          },
        });
        this.showAlert(
          this.$t('BULK_ACTION.TEAMS.ASSIGN_SUCCESFUL'),
          'success'
        );
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.TEAMS.ASSIGN_FAILED'), 'error');
      }
    },
    async onAssignLabelsBulk(labels) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Conversation',
          ids: this.conversations,
          labels: {
            add: labels,
          },
        });

        this.showAlert(
          this.$t('BULK_ACTION.LABELS.ASSIGN_SUCCESFUL'),
          'success'
        );
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.LABELS.ASSIGN_FAILED'), 'error');
      }
    },
    async onAssignAgentBulk(agent) {
      try {
        await this.$store.dispatch('bulkActions/process', {
          type: 'Conversation',
          ids: this.conversations,
          fields: {
            assignee_id: agent.id,
          },
        });

        this.showAlert(this.$t('BULK_ACTION.ASSIGN_SUCCESFUL'), 'success');
      } catch (err) {
        this.showAlert(this.$t('BULK_ACTION.ASSIGN_FAILED'), 'error');
      }
    },
  },
};
